<div class="header-container">
  <div class="header-info-line" [style.background]="
  'linear-gradient(to left, rgba(var(--app-surface-rgb), 0.8) 0%, rgba(var(--app-surface-rgb), 0) 80%), ' + plan.color
">
    <h3>Lorem ipsum ...</h3>
  </div>
  <mat-card-header>
    <mat-card-title>
      <h2>{{ plan.packageClass }}</h2>
      <!-- <div *ngIf="loggedIn" class="price"> -->
      <div class="price">
        <span class="amount">{{ plan.unitAmount/1200 }}</span>
        <span class="currency">&nbsp;€</span>
        <span class="period">pro Monat*</span>
      </div>
    </mat-card-title>
    <!-- <mat-card-subtitle *ngIf="loggedIn"> -->
    <mat-card-subtitle>
      <div class="yearly-price">
        Jahresrechnung über {{ plan.unitAmount/100 }} €
      </div>
    </mat-card-subtitle>
  </mat-card-header>
</div>

<mat-card-content [style.paddingBottom]="'24px'">
  <ul>
    <span *ngFor="let feature of plan.listItems; let i = index"
      [ngStyle]="{ 'background-color': i % 2 === 0 ? 'var(--app-surface)' : 'transparent' }"
      class="li-container dis-flx align-cen apart">
      <li class="feature-text">{{ feature.name }}</li>
      <div class="icon-check-gr"></div>
    </span>
  </ul>
</mat-card-content>